<i18n>
{
  "en": {
    "hi": "Hi",
    "welcome": "Welcome to XRobotmon",
    "loading_licenses": "Loading licenses...",
    "you_have": "You have",
    "valid_license": "valid licenses",
    "games": "Games",
    "not-subscribed-to-games": "You are not currently subscribed to any games",
    "try-it-for-free-now": "Try it for free now",
    "select_plan": "Subscribe XRobotmon",
    "applyTrialPlan": "Unlimited one hour free trial!",
    "new_version": "XRobotmon detected new version and is updating, one moment please.",
    "chooseTrialGame": "What do you like to play?",
    "back": "back",
    "unknownError": "Something wrong! Please refresh website.",
    "already-subscribed": "Already have a game subscription? Try logging in with another account",
    "tsum": "Tsum Tsum",
    "cookieKingdom": "Cookie Kingdom",
    "mlb9i": "MLB 9 Innings",
    "all": "All",
    "linkGoogleInfo": "Starting August 15, 2025, Facebook login will no longer be supported. Please link your Google account as soon as possible.",
    "linkGoogleFailed1": "Link failed, this Google account is already linked to another XRobotmon account",
    "linkGoogleFailed2": "Please contact support to help transfer your data and provide the following information",
    "linkGoogleSuccess": "Link Google success",
    "fb_noLicenses": "You are currently using Facebook login, but we have disabled Facebook login. Please use Google login instead (You currently have no licenses)",
    "dialog_title_login_method_change": "Login Method Change",
    "dialog_title_google_link_success": "Google Link Success", 
    "dialog_title_google_link_failed": "Google Link Failed",
    "dialog_title_error": "Error",
    "link_google_now": "Link Google Now",
    "copy_info": "Copy Info",
    "copied_to_clipboard": "Copied to clipboard",
    "copy_error": "Error: Unable to copy automatically. Please copy manually.",
    "contact_customer_service": "Please contact customer service for assistance."
  },
  "zhHant": {
    "hi": "嗨",
    "welcome": "歡迎來到 XRobotmon",
    "loading_licenses": "正在讀取您的授權...",
    "you_have": "您目前有",
    "valid_license": "個有效的授權",
    "games": "遊戲",
    "not-subscribed-to-games": "您目前沒有訂閱任何遊戲",
    "try-it-for-free-now": "立即免費試用",
    "select_plan": "立即訂閱 XRobotmon",
    "applyTrialPlan": "無限次數免費試用1小時",
    "new_version": "偵測到XRobotmon新版本，正在更新中，請稍待片刻。",
    "chooseTrialGame": "今天要玩什麼呢？",
    "back": "返回",
    "unknownError": "發生未知錯誤，請嘗試重新整理網頁再試一次。",
    "already-subscribed": "已經訂閱過遊戲？ 嘗試用其他帳號登入",
    "tsum": "Tsum Tsum",
    "cookieKingdom": "薑餅人王國",
    "mlb9i": "MLB 9局職棒",
    "all": "全部",
    "linkGoogleInfo": "2025/8/15後，我們即將不支援 Facebook 登入，請盡快連結 Google 帳號。",
    "linkGoogleFailed1": "連結失敗，此 Google 帳號已連結過其他 XRobotmon 帳號",
    "linkGoogleFailed2": "請聯絡客服協助您轉移資料，並提供以下資訊",
    "linkGoogleSuccess": "連結 Google 成功",
    "fb_noLicenses": "您正在使用 Facebook 登入，但我們已經停用 Facebook 登入，請使用 Google 登入 (您目前沒有任何授權)",
    "dialog_title_login_method_change": "登入方式變更",
    "dialog_title_google_link_success": "Google 連結成功",
    "dialog_title_google_link_failed": "Google 連結失敗",
    "dialog_title_error": "發生錯誤",
    "link_google_now": "立即連結 Google",
    "copy_info": "複製資訊",
    "copied_to_clipboard": "已複製到剪貼板",
    "copy_error": "錯誤：無法自動複製，請手動複製。",
    "contact_customer_service": "請聯繫客服尋求協助。"
  },
  "ja": {
    "hi": " ",
    "welcome": " さん、XRobotmonへようこそ！",
    "loading_licenses": "読み込み中...",
    "you_have": "ご利用中のライセンスが",
    "valid_license": "件あります。",
    "games": "ゲーム",
    "not-subscribed-to-games": "現在どのゲームにも登録していません",
    "try-it-for-free-now": "今すぐ無料でお試しください",
    "select_plan": "今すぐXRobotmonを購入する",
    "applyTrialPlan": "無料トライアル",
    "new_version": "新しいバージョンがあり、ページが再読み込みされます。暫くお待ちください。",
    "chooseTrialGame": "サポートゲーム一覧",
    "back": "戻る",
    "unknownError": "不明なエラーが発生しました。ページを更新して再度お試しください。",
    "already-subscribed": "すでにゲームのサブスクリプションをお持ちですか?別のアカウントでログインしてみてください",
    "tsum": "ツムツム",
    "cookieKingdom": "クッキーキングダム",
    "mlb9i": "MLB 9イニングス",
    "all": "全て",
    "linkGoogleInfo": "2025年8月15日以降、Facebook ログインのサポートを終了いたします。お早めにGoogle アカウントの連携をお願いいたします。",
    "linkGoogleFailed1": "申し訳ございませんが、連携できませんでした。こちらのGoogleアカウントは既に別のXRobotmonアカウントに連携済みです",
    "linkGoogleFailed2": "データ移行についてカスタマーサポートまでご連絡いただき、下記の情報をお知らせください",
    "linkGoogleSuccess": "Googleアカウントの連携が正常に完了いたしました",
    "fb_noLicenses": "現在Facebook ログインをご利用いただいておりますが、Facebook ログインは停止いたしました。Google ログインをご利用ください（現在ライセンスをお持ちではありません）",
    "dialog_title_login_method_change": "ログイン方式変更",
    "dialog_title_google_link_success": "Google連携完了",
    "dialog_title_google_link_failed": "Google連携エラー",
    "dialog_title_error": "エラー",
    "link_google_now": "今すぐGoogle連携",
    "copy_info": "コピー情報",
    "copied_to_clipboard": "クリップボードにコピー",
    "copy_error": "エラー：自動コピーできませんでした。手動でコピーしてください。",
    "contact_customer_service": "カスタマーサービスにお問い合わせください。"
  },
  "ko": {
    "hi": "안녕하세요",
    "welcome": "XRobotmon에 오신 것을 환영합니다.",
    "loading_licenses": "라이센스 확인중...",
    "you_have": "당신은 현재",
    "valid_license": "개의 라이센스를 가지고 있습니다.",
    "games": "게임",
    "not-subscribed-to-games": "현재 구독 중인 게임이 없습니다.",
    "try-it-for-free-now": "지금 무료로 사용해 보세요",
    "select_plan": "XRobotmon 라이센스 결제",
    "applyTrialPlan": "무료로 체험해보세요.",
    "new_version": "XRobotmon의 새로운 버전이 발견되었습니다. 업데이트중입니다.",
    "chooseTrialGame": "무료체험할 게임을 선택해주세요.",
    "back": "이전 페이지",
    "unknownError": "알수 없는 오류, 페이지를 새로고침하고 다시 시도해주세요.",
    "already-subscribed": "이미 게임을 구독하고 계십니까? 다른 계정으로 로그인해 보세요",
    "tsum": "라인 디즈니 썸썸",
    "cookieKingdom": "쿠키런: 킹덤",
    "mlb9i": "MLB 9이닝스",
    "all": "모두",
    "linkGoogleInfo": "2025년 8월 15일부터 Facebook 로그인 지원을 중단합니다. 빠른 시일 내에 Google 계정을 연결해 주세요.",
    "linkGoogleFailed1": "연결에 실패했습니다. 이 Google 계정은 이미 다른 XRobotmon 계정에 연결되어 있습니다",
    "linkGoogleFailed2": "데이터 이전을 위해 고객지원에 문의하시고 다음 정보를 제공해 주세요",
    "linkGoogleSuccess": "Google 링크에 성공했습니다.",
    "fb_noLicenses": "현재 Facebook 로그인을 사용하고 계시지만, Facebook 로그인은 중단되었습니다. Google 로그인을 이용해 주세요 (현재 라이센스가 없습니다)",
    "dialog_title_login_method_change": "로그인 방법 변경",
    "dialog_title_google_link_success": "Google 링크 성공",
    "dialog_title_google_link_failed": "Google 링크 실패",
    "dialog_title_error": "오류 발생",
    "link_google_now": "지금 Google 연결",
    "copy_info": "복사 정보",
    "copied_to_clipboard": "클립보드에 복사",
    "copy_error": "오류: 자동 복사를 할 수 없습니다. 수동으로 복사해주세요.",
    "contact_customer_service": "고객 서비스에 문의해 주세요."
  }
}
</i18n>

<template>
  <div>
    <v-container v-if="shouldLinkGoogle">
      <v-layout row justify-space-between align-center>
        <div>{{ $t('linkGoogleInfo') }}</div>
      </v-layout>
      <v-layout row justify-space-between align-center>
        <v-btn block color="warning" @click="linkGoogle">{{ $t('link_google_now') }}</v-btn>
      </v-layout>
    </v-container>
    <v-container>
      <v-layout row justify-space-between align-center>
        <h2>
          {{ $t(selectedGame) }} |
          <span :style="{ color: '#1976D2' }">{{ Object.keys(displayGames).length }}</span>
        </h2>
        <!-- games filter -->
        <div>
          <v-menu>
            <template v-slot:activator="{ on }"><v-btn icon color="transparent" v-on="on">
                <v-icon>mdi-sort</v-icon></v-btn></template>
            <v-list>
              <v-list-tile v-for="(game, id) in games" :key="id" @click="selectGame(game)">
                <v-list-tile-title :style="selectedGame === game.value && 'font-weight: bold'">
                  <div class="filter-option">
                    <div class="filter-image-wrapper">
                      <img :src="game.icon" width="20" height="20" />
                    </div>
                    {{ $t(game.value) }}
                  </div>
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </v-layout>
    </v-container>
    <v-container pa-2>
      <v-layout>
        <Bulletin style="width: 100%" :licenses="licenses"></Bulletin>
      </v-layout>
    </v-container>
    <v-container v-if="isLoading">
      <Spinner />
    </v-container>
    <v-container v-show="!isLoading && numLicense === 0">
      <div class="no-games-container">
        <img :src="noGamesImage" alt="No games" class="no-games-image" />
        <p>
          {{ $t('not-subscribed-to-games') }}<br />
          {{ $t('try-it-for-free-now') }}
        </p>
      </div>
    </v-container>
    <!-- TODO: put ad here when no game in displayGames -->
    <v-container v-show="!isLoading && numLicense !== 0 && Object.keys(displayGames).length === 0">
      <v-layout justify-center align-center>
        <p class="text-md-center">There is no game in {{ selectedGame }}</p>
      </v-layout>
    </v-container>
    <v-container fluid grid-list-md pa-2>
      <v-layout row wrap>
        <v-flex :id="'deviceCardFlex'" xs12 sm12 md6 lg4 xl3 v-for="(license, licenseId) in displayGames"
          :key="licenseId">
          <DeviceCard :license="license" @updateLicenseById="updateLicenseById" @updateCardSize="updateCardSize" />
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid grid-list-md justify-center>
      <v-dialog v-model="showApplyFreeTrialDialog" max-width="95%">
        <v-card>
          <v-card-title primary-title v-bind:style="{ background: '#1976D2', color: 'white' }">
            <h3 class="headline mb-0">{{ $t('chooseTrialGame') }}</h3>
          </v-card-title>
          <v-card-text class="pa-2">
            <v-layout row wrap>
              <v-flex xs12 sm6 md4>
                <TsumIntro small :mode="mode" />
                <v-divider class="mt-2" />
              </v-flex>
              <v-flex xs12 sm6 md4>
                <CookieKingdomIntro small :mode="mode" />
                <v-divider class="mt-2" />
              </v-flex>
              <v-flex xs12 sm6 md4>
                <MLB9InningsIntro small :mode="mode" />
                <v-divider class="mt-2" />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-flex class="pb-1 px-2">
              <v-btn @click="showApplyFreeTrialDialog = false" color="warning" block outline>
                {{ $t('back') }}
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <div class="cta-buttons">
        <v-btn block outline color="primary" class="cta-button" @click="
          mode = 'trial';
        showApplyFreeTrialDialog = true;
        ">
          {{ $t('applyTrialPlan') }}
        </v-btn>

        <v-btn block color="primary" class="cta-button" @click="
          mode = 'subscribe';
        showApplyFreeTrialDialog = true;
        ">
          {{ $t('select_plan') }}
        </v-btn>
      </div>
    </v-container>
    <!-- tips -->
    <div v-show="!isLoading && numLicense === 0" class="tips-container">
      <div :style="{ width: '400px' }">
        <div class="tips">{{ $t('already-subscribed') }}</div>
      </div>
    </div>

    <!-- 訊息對話框 -->
    <v-dialog v-model="showMessageDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline white--text" :class="messageDialogColor">
          {{ messageDialogTitle }}
        </v-card-title>
        <v-card-text>
          <div v-html="messageDialogContent"></div>
          <ContactInfo v-if="showContactInfoInDialog" />
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="showCopyButton" :color="messageDialogColor" outlined v-clipboard:copy="copyText"
            v-clipboard:success="onCopySuccess" v-clipboard:error="onCopyError">
            <v-icon left>mdi-content-copy</v-icon>
            {{ $t('copy_info') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn :color="messageDialogColor" text @click="closeDialog">
            確認
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import DeviceCard from '../components/DeviceCard';
import Bulletin from '../components/Bulletin';
import { ConnectingState, GameOptions } from '../store/enum';
import TsumIntro from '../components/intro.TsumTsum';
import CookieKingdomIntro from '../components/intro.CookieKingdom';
import MLB9InningsIntro from '../components/intro.MLB9Innings';
import * as Util from '../misc/util';
import assetMisc from '@/assets/misc';
import Spinner from '@/components/ui/Spinner';
import ContactInfo from '../components/ContactInfo';

export default {
  name: 'home',
  components: { DeviceCard, Bulletin, TsumIntro, CookieKingdomIntro, MLB9InningsIntro, Spinner, ContactInfo },
  data() {
    return {
      mode: 'trial', // 'trial' 'subscribe'
      userProfile: null,
      licenses: {},
      isLoadingLicenses: true,
      webRTCConnection: null,
      webRTCSession: '',
      unsubscribe: null,
      showApplyFreeTrialDialog: false,
      GameOptions: GameOptions,
      noGamesImage: assetMisc.noGamesUrl,
      isLoading: false,
      games: [
        { value: 'all', icon: assetMisc.allIcons },
        { value: 'tsum', icon: assetMisc.tsumLogoUrl },
        { value: 'mlb9i', icon: assetMisc.mlb9iLogoUrl },
        { value: 'cookieKingdom', icon: assetMisc.cookieKingdomLogoUrl },
      ],
      selectedGame: 'all',
      allIcons: assetMisc.allIcons,
      shouldLinkGoogle: false,
      // 新增對話框相關的 data
      showMessageDialog: false,
      messageDialogTitle: '',
      messageDialogContent: '',
      messageDialogColor: 'primary',
      shouldSignOutAfterDialog: false,
      shouldReloadAfterDialog: false,
      showContactInfoInDialog: false,
      // 新增複製相關的 data
      copyText: '',
      showCopyButton: false,
    };
  },
  async created() {
    if (firebase.auth().currentUser) {
      this.$set(this, 'userProfile', firebase.auth().currentUser);
    }

    if (this.userProfile) {
      // await this.checkVersion();
      await this.getLicenses();
      // if provider is facebook, force to connect to google
      if (this.userProfile.providerData.length === 1 && this.userProfile.providerData[0].providerId === 'facebook.com') {
        this.shouldLinkGoogle = true;
        if (Object.keys(this.licenses).length === 0) {
          this.showDialog(this.$t('dialog_title_login_method_change'), this.$t('fb_noLicenses'), 'warning');
          this.shouldSignOutAfterDialog = true;
        }
      }
      // poke firestore write 5 times interval 55 sec
      for (let i = 0; i < 5; i++) {
        await this.pokeFirestoreWrite();
        await Util.delay(55000);
      }
    }
  },
  mounted() {
    console.log('selected game', this.selectedGame);
  },
  computed: {
    numLicense() {
      return Object.keys(this.licenses).length;
    },
    displayGames() {
      if (this.selectedGame === null || this.selectedGame === 'all') {
        return this.licenses;
      }
      return Object.fromEntries(
        Object.entries(this.licenses).filter(([, value]) => {
          return value.supportGame === this.selectedGame;
        })
      );
    },
  },
  methods: {
    // 顯示對話框的方法
    showDialog(title, content, color = 'primary', showContactInfo = false, copyText = '') {
      this.messageDialogTitle = title;
      this.messageDialogContent = content;
      this.messageDialogColor = color;
      this.showContactInfoInDialog = showContactInfo;
      this.copyText = copyText;
      this.showCopyButton = copyText !== '';
      this.showMessageDialog = true;
    },

    // 關閉對話框的方法
    async closeDialog() {
      this.showMessageDialog = false;
      this.showContactInfoInDialog = false;
      this.showCopyButton = false;
      this.copyText = '';
      if (this.shouldSignOutAfterDialog) {
        this.shouldSignOutAfterDialog = false;
        await firebase.auth().signOut();
        window.location.reload();
      } else if (this.shouldReloadAfterDialog) {
        this.shouldReloadAfterDialog = false;
        window.location.reload();
      }
    },

    // v-clipboard 成功回調
    onCopySuccess() {
      alert(this.$t('copied_to_clipboard'));
    },

    // v-clipboard 失敗回調
    onCopyError() {
      alert(this.$t('copy_error'));
    },

    async linkGoogle() {
      const googleProvider = new firebase.auth.GoogleAuthProvider();
      try {
        const result = await firebase.auth().currentUser.linkWithPopup(googleProvider);
        console.log('link with google');
        console.log('result', result);

        // 獲取連結的 Google 帳號 email
        const googleProviderData = result.user.providerData.find(provider => provider.providerId === 'google.com');
        const googleEmail = googleProviderData ? googleProviderData.email : 'Unknown';
        const successMessage = `${this.$t('linkGoogleSuccess')}<br>Google Email: ${googleEmail}`;

        this.showDialog(this.$t('dialog_title_google_link_success'), successMessage, 'success');
        this.shouldReloadAfterDialog = true;
      } catch (e) {
        if (e.code === 'auth/credential-already-in-use') {
          // 不執行 signInWithCredential，避免登出當前用戶
          // 從錯誤對象中獲取可用的信息
          const email = e.email || 'unknown';
          const message = `${this.$t('linkGoogleFailed1')}`
            + `<br>${this.$t('linkGoogleFailed2')}`
            + `<br>XRobotmon ID: ${this.userProfile.uid}`
            + `<br>Google Account Email: ${email}`;

          // 準備要複製的純文本
          const copyText = `XRobotmon ID: ${this.userProfile.uid}\nGoogle Account Email: ${email}`;

          this.showDialog(this.$t('dialog_title_google_link_failed'), message, 'error', true, copyText);
        } else {
          // 其他未預期的錯誤，交給客服處理
          const errorMessage = `Error Code: ${e.code || 'unknown'}<br>Error Message: ${e.message || 'Unknown error'}<br><br>${this.$t('contact_customer_service')}`;
          this.showDialog(this.$t('dialog_title_google_link_failed'), errorMessage, 'error', true);
        }
        console.log('e', e);
      }
    },
    async pokeFirestoreWrite() {
      for (const key in this.licenses) {
        const license = this.licenses[key];
        if (license.device === null) {
          continue;
        }
        const device = license.device;
        try {
          await firebase
            .firestore()
            .collection('x_webrtc')
            .doc('device_' + device.deviceId)
            .update({
              dummy: Date.now(),
            });
          console.log('poke firestore write');
        } catch (e) {
          console.log(e);
        }
        break;
      }
    },
    async getLicenses() {
      this.isLoading = true;
      await Util.timeoutRetry(
        async () => {
          const response = await firebase.functions().httpsCallable('xGetLicenses')();

          const mappedLicenses = response.data.licenses.reduce(function (map, obj) {
            map[obj.licenseId] = obj;
            return map;
          }, {});

          for (const licenseId in mappedLicenses) {
            if (mappedLicenses[licenseId].device != null) {
              mappedLicenses[licenseId].device.StreamingState = ConnectingState.OFFLINE;

              mappedLicenses[licenseId].startState = ConnectingState.ONLINE;
            } else {
              mappedLicenses[licenseId].startState = ConnectingState.OFFLINE;
            }
          }

          let sortedMapLicense = new Map();
          if (Object.keys(mappedLicenses).length > 0) {
            Object.keys(mappedLicenses)
              .sort((a, b) => (mappedLicenses[a].licenseId > mappedLicenses[b].licenseId ? 1 : -1))
              .forEach(key => {
                sortedMapLicense[key] = mappedLicenses[key];
              });
          }

          this.isLoadingLicenses = false;
          this.$set(this, 'licenses', Object.assign({}, sortedMapLicense));
        },
        async () => {
          this.showDialog(this.$t('dialog_title_error'), this.$t('unknownError'), 'error');
        },
        3
      );
      this.isLoading = false;
    },
    select_plan() {
      this.$router.push({ name: 'plan' });
    },
    updateLicenseById(license) {
      this.$set(this.licenses, license.licenseId, license);
    },
    updateCardSize(screenClass, width) {
      var element = document.getElementById('deviceCardFlex');
      var currentClass = element.className;
      var currentWidth = currentClass.match(new RegExp(screenClass + '(\\d+)'))[1];
      var newClass = currentClass.replace(screenClass + currentWidth, screenClass + width);
      element.className = newClass;
    },
    async checkVersion() {
      let shouldRefresh = false;
      const currentAPIVersion = 2;
      try {
        const result = await firebase.functions().httpsCallable('XRobotmonGroup-xGetVersion', { timeout: 5 * 1000 })();
        const version = result.data;
        if (currentAPIVersion !== version) {
          shouldRefresh = true;
        }
      } catch (e) {
        // TODO
        console.log(e);
      }
      if (shouldRefresh) {
        alert(this.$i18n.t('new_version'));
        // force reload all web data
        window.location.reload(true);
      }
    },
    selectGame(game) {
      this.selectedGame = game.value;
      console.log(game);
    },
  },
};
</script>

<style scoped>
.no-games-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.no-games-container>p {
  text-align: center;
}

.no-games-image {
  width: 65%;
  height: 65%;
  max-width: 400px;
  max-height: 400px;
}

.cta-buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.cta-button {
  max-width: 400px;
  height: 100%;
  margin: 0;
  padding: 8px 16px;
}

.tips-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px auto 32px auto;
  padding: 0 16px;
}

.tips {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  background-color: #fbe9e7;
  border-radius: 4px;
  text-align: center;
  width: 100%;
}

.filter-option {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 8px;
}

.filter-image-wrapper {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  overflow: hidden;
}
</style>
